// extracted by mini-css-extract-plugin
export default {"createDiagram":"CreateDiagram_createDiagram__mqO3h","imageContainer":"CreateDiagram_imageContainer__KEmku","diagramTextInput":"CreateDiagram_diagramTextInput__A3sY4"};